import React from "react";
import webcrawlerChatbotLogo from "../../assets/webcrawlerchatbot_logo.jpg";

export default function Title() {
  return (
    <div className='bg-white w-full h-24 flex items-center justify-center'>
      <div className='flex items-center'>
        <a target='_blank' href="https://www.excelitte.com/excelitte-web-crawler.html">
          <img src={webcrawlerChatbotLogo} alt='Logo' className='h-44' />
        </a>
      </div>
    </div>
  );
}
